/**
 * Blocks Design Lab actions the current visitor is not entitled to.
 *
 * The lab builds save / add-sample / add-to-cart / spec-sheet buttons at
 * runtime, so Liquid cannot remove them. snippets/zellij-lab-action-gate.liquid
 * hides them with CSS; this file stops the click as well, in case a button is
 * re-shown or reached by keyboard. Capture phase, so it runs before the lab's
 * own handlers - the same tactic as zellij-lab-svg-gate.js.
 *
 * Client-side only. This is a funnel, not an entitlement check.
 */
(function () {
  'use strict';

  if (window.ZellijLabActionGate) return;

  var caps = window.ZELLIJ_CAPS || {};

  var RULES = [
    { cap: 'save', selector: '.zellij-lab__btn-save, .zellij-lab__chrome-save' },
    { cap: 'sample', selector: '.zellij-lab__btn-add-sample, .zellij-funnel-order__cta--sample' },
    { cap: 'order', selector: '.zellij-lab__btn-add-to-cart, .zellij-funnel-order__cta--full' },
    { cap: 'guide', selector: '.zellij-lab__btn-spec-sheet' }
  ];

  var blocked = RULES.filter(function (r) {
    return caps[r.cap] !== true;
  });

  if (!blocked.length) return;

  var blockedSelector = blocked
    .map(function (r) {
      return r.selector;
    })
    .join(', ');

  function matchedRule(el) {
    for (var i = 0; i < blocked.length; i++) {
      if (el.matches && el.matches(blocked[i].selector)) return blocked[i];
      if (el.closest && el.closest(blocked[i].selector)) return blocked[i];
    }
    return null;
  }

  function onInteraction(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var el = target.closest(blockedSelector);
    if (!el) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var rule = matchedRule(el) || {};
    document.dispatchEvent(
      new CustomEvent('zellij:lab-action-blocked', {
        detail: { capability: rule.cap || null, signedIn: caps.signedIn === true }
      })
    );
    openGateDialog();
  }

  // Built on demand: this script's config is emitted in <head>, where a
  // <dialog> element would be invalid markup.
  var dialogEl = null;

  // Locale strings arrive HTML-escaped (e.g. "You&#39;re almost there"), because
  // Shopify's translation files store them that way. textContent does not decode
  // entities, so decode first. A detached <textarea> is the safe idiom: its
  // innerHTML is parsed as character data, so no markup or script can execute.
  function decodeEntities(str) {
    if (!str) return '';
    if (str.indexOf('&') === -1) return str;
    var ta = document.createElement('textarea');
    ta.innerHTML = str;
    return ta.value;
  }

  function buildDialog() {
    var d = caps.dialog || {};
    var signedIn = caps.signedIn === true;
    var el = document.createElement('dialog');
    el.className = 'zh-gate-dialog';

    var inner = document.createElement('div');
    inner.className = 'zh-gate-dialog__inner';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'zh-gate-dialog__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&times;';
    close.addEventListener('click', function () { el.close(); });

    var title = document.createElement('h2');
    title.className = 'h5 zh-gate-dialog__title';
    title.textContent = decodeEntities(signedIn ? d.title : d.guestTitle);

    var body = document.createElement('p');
    body.textContent = decodeEntities(signedIn ? d.body : d.guestBody);

    var actions = document.createElement('div');
    actions.className = 'zh-gate-dialog__actions';

    function cta(label, href, quiet) {
      if (!label || !href) return null;
      var a = document.createElement('a');
      a.className = 'zh-gate-dialog__cta' + (quiet ? ' zh-gate-dialog__cta--quiet' : '');
      a.href = href;
      a.textContent = decodeEntities(label);
      return a;
    }

    var primary = signedIn
      ? cta(d.applyLabel, d.applyUrl, false)
      : cta(d.loginLabel, d.loginUrl, false);
    if (primary) actions.appendChild(primary);

    if (!signedIn) {
      var secondary = cta(d.applyLinkLabel, d.applyUrl, true);
      if (secondary) actions.appendChild(secondary);
    }

    inner.appendChild(close);
    inner.appendChild(title);
    inner.appendChild(body);
    inner.appendChild(actions);
    el.appendChild(inner);

    // Click on the backdrop closes it.
    el.addEventListener('click', function (event) {
      if (event.target === el) el.close();
    });

    document.body.appendChild(el);
    return el;
  }

  function openGateDialog() {
    if (!caps.dialog) return;
    if (!dialogEl) dialogEl = buildDialog();
    if (typeof dialogEl.showModal === 'function') {
      if (!dialogEl.open) dialogEl.showModal();
    } else {
      dialogEl.setAttribute('open', '');
    }
  }

  // Capture phase on both, so keyboard activation is covered too.
  document.addEventListener('click', onInteraction, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    onInteraction(event);
  }, true);

  window.ZellijLabActionGate = {
    caps: caps,
    blocked: blocked.map(function (r) {
      return r.cap;
    })
  };
})();
